import {
  border,
  breakpoints,
  colors,
  primaryFont,
  radius,
  secondaryFont,
  shadow,
  spacing,
} from '@thrivent/midwest-shared';
import { DefaultTheme } from 'styled-components';

export * from './globalStyles';

declare module 'styled-components' {
  export interface DefaultTheme {
    font: {
      primary: string;
      secondary: string;
    };
    spacing: typeof spacing;
    shadow: typeof shadow;
    radius: typeof radius;
    breakpoints: typeof breakpoints;
    midwestColors: typeof colors;
    border: typeof border;
  }
}

/**
 * @deprecated Use theme from Midwest-Web instead, e.g. import { theme } from '@midwest/web/theme';.
 *
 * ```tsx
 *  import { theme } from '@midwest/web/theme';
 * ```
 */
export const theme: DefaultTheme = {
  font: {
    primary: primaryFont,
    secondary: secondaryFont,
  },
  spacing: spacing,
  shadow: shadow,
  radius: radius,
  breakpoints: breakpoints,
  midwestColors: colors,
  border: border,
};
